import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface DeviceType {
  device_type_id: number;
  device_name: string;
  category_id: number;
  category_name: string;
}

interface BaseModel {
  code: string;
  base_model_code: string;
  display_name: string;
  name: string;
  description: string;
  brand: string;
  lifecycle_status: string;
  manufacturer_part_number: string;
  device_type: DeviceType;
}

interface Brand {
  manufacturer: string;
  brand: string;
  device_type: string[];
  category: string[];
  basemodel_count: number;
  equipment_type: string[];
}

interface ProductsState {
  brands: Brand[];
  baseModels: BaseModel[];
  brandsLoaded: boolean;
  baseModelsLoaded: boolean;
}

const initialState: ProductsState = {
  brands: [],
  baseModels: [],
  brandsLoaded: false,
  baseModelsLoaded: false,
};

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setBrands(state, action: PayloadAction<Brand[]>) {
      state.brands = action.payload;
      state.brandsLoaded = true;
    },
    setBaseModels(state, action: PayloadAction<BaseModel[]>) {
      state.baseModels = action.payload;
      state.baseModelsLoaded = true;
    },
    clearProducts(state) {
      state.brands = [];
      state.baseModels = [];
      state.brandsLoaded = false;
      state.baseModelsLoaded = false;
    },
  },
});

export const { setBrands, setBaseModels, clearProducts } = productsSlice.actions;
export const productsReducer = productsSlice.reducer;
